表现举例：预览>
<template>
  <span
    class="text-arrow"
    :class="{'right':rightAlign}"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ text }}
    <van-icon name="arrow" />
  </span>
</template>

<script>
import { Icon } from 'vant';

export default {
  name: 'TextArrow',
  components: { [Icon.name]: Icon },
  props: {
    text: {
      type: String,
      default: '',
    },
    // 是否右对齐
    rightAlign: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-arrow {
  display: flex;
  align-items: center;
  color:blue;
}
.right {
  justify-content: flex-end;
}
</style>
